var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"health"},[_c('div',{staticClass:"head"},[_c('Navigator'),_c('h3',[_vm._v("消费品行业")]),_c('p',[_vm._v("Consumer goods industry")])],1),_c('Content',{attrs:{"data":_vm.content}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }